<template>
  <div 
    id="mfaModal" 
    class="switchAccModal modal fade" 
    role="dialog"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content modal_wrapper">
        <div class="modal-header mfaModal-bgcolor">
          <div class="modal-title header-props pt-30">
            <div class="col-xs-12 col-sm-12 p-0">
              Enter the OTP shared in your email
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row ml-30 mr-30">
            <div
              class="col-xs-12 col-sm-12"
            >
              <div
                class="form-group"
              >
                <label>Enter OTP (One time password)</label>
                <input
                  v-model="otp"
                  type="text"
                  maxlength="10"
                  class="form-control"
                  placeholder="Enter OTP"
                  @keydown="allownumbers"
                >
              </div>
              <div class="form-group resend-row">
                <span
                  class="resend-timer"
                > Didn't recieve the code?</span>
                <span 
                  v-if="resendDisabled" 
                  class="fw-500 pl-5"
                >
                  Resend {{ `(${resendTimer}s)` }}
                </span>
                <a
                  v-if="!resendDisabled"
                  class="resend-link"
                  @click.prevent="resendOtp"
                >
                  Resend OTP
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer mfaModal-bgcolor">
          <button
            type="button"
            class="btn ml-20 emergo-green-button"
            :disabled="otp === ''"
            @click="proceed()"
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
    <loader :loading-status="loaderStatus" />
  </div>
</template>
<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/SearchBox.vue';
import { validateMfaOtp, regenrateMfaOtp } from '../../apis/mfa';

export default {
  components: {
    Loader,
    SearchBox
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ['redirectUrl'],
  data() {
    return {
      loaderStatus: false,
      otp: '',
      otpErr: '',
     resendTimer: 0,
     resendDisabled: false,
     resendInterval: null,
    };
  },
  computed: {},
  created() {},
  mounted() {
    $('#mfaModal').on('shown.bs.modal', async () => {});
  },
 beforeUnmount() {
   if (this.resendInterval) {
     clearInterval(this.resendInterval);
     this.resendInterval = null;
   }
   this.emitter.off('reinitiatePage');
 },
  methods: {
    allownumbers(event) {
      const allowedKeys = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',

    ];

    const pattern = /^\d+$/;

    // Allow control keys (Backspace, Delete, etc.)
    if (allowedKeys.includes(event.key)) {
        return;
    }
     // Allow copy-paste shortcuts (Ctrl+V, Ctrl+C, Ctrl+A)
    if ((event.ctrlKey || event.metaKey) && ['v', 'c', 'a'].includes(event.key.toLowerCase())) {
      return;
    }
    // Block everything except digits
    if (!pattern.test(event.key)) {
        event.preventDefault();
    }
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    clearStep() {
      this.otpErr = '';
      this.clearNotifications();
      this.otp = '';
      this.step = 1;
    },
   startResendTimer() {
     if (this.resendInterval) {
       clearInterval(this.resendInterval);
     }
     this.resendInterval = setInterval(() => {
       if (this.resendTimer > 0) {
         this.resendTimer -= 1;
       } else {
         clearInterval(this.resendInterval);
         this.resendInterval = null;
         this.resendDisabled = false;
       }
     }, 1000);
   },
   async resendOtp() {
     if (this.resendDisabled) return;
     this.resendDisabled = true;
     this.resendTimer = 60; // 1 minute
     this.startResendTimer();
     try {
       this.loaderStatus = true;
       const payload = { user_email: this.data.user_email, api: this.data.api };
       const response = await regenrateMfaOtp(payload);
       if (response && (response.status_code === 200 || response.status === 200)) {
        this.otp = '';
         this.clearNotifications();
         this.$notify({
           type: 'success',
           title: 'OTP sent',
           text: 'A new OTP has been sent to your email.',
           group: 'custom-notification'
         });
       } else {
         // on failure, stop timer and re-enable so user can retry
         clearInterval(this.resendInterval);
         this.resendInterval = null;
         this.resendDisabled = false;
         this.resendTimer = 0;
         this.clearNotifications();
         this.$notify({
           type: 'error',
           title: 'Error',
           text: (response && response.message) || 'Failed to resend OTP',
           group: 'custom-notification'
         });
       }
     } catch (err) {
       clearInterval(this.resendInterval);
       this.resendInterval = null;
       this.resendDisabled = false;
       this.resendTimer = 0;
       this.$notify({
         type: 'error',
         title: 'Error',
         text: 'Failed to resend OTP',
         group: 'custom-notification'
       });
     } finally {
       this.loaderStatus = false;
     }
   },
    async proceed() {
      this.otpErr = '';
      this.clearNotifications();
      this.loaderStatus = true;
      const response = await validateMfaOtp({ otp: this.otp, user_email: this.data.user_email, api: this.data.api });
      if (response && response.status_code === 200 && response.message !== 'failed') {
        $('#mfaModal').modal('hide');
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'OTP verified successfully',
          group: 'custom-notification'
        });
        this.loaderStatus = false;
        this.otp = '';
        //  window.location.reload();
        this.emitter.emit('reinitiatePage');
      } else {
        this.loaderStatus = false;
        this.$notify({
          type: 'error',
          title: 'Error',
          text: (response && response.data) || 'Something went wrong',
          group: 'custom-notification'
        });
      }
    }
  },
};
</script>
<style scoped lang="scss">
.resend-row {
  margin-top: 12px;
  text-align: right;
  .resend-link {
    cursor: pointer;
    color: $primary;
    margin-left: 5px;
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
  .resend-timer {
    margin-left: 6px;
    color: #666;
  }
}
.switchAccModal {
  .modal-dialog {
    width: 490px;
    height: 656px;
  }

  .mfaModal-bgcolor {
    background-color: $white;
    border: 0px;
    border-radius: 10px;
    margin: 15px 20px;
  }

  .header-props {
    @include fontItems(22px, 26px, $font-weight-medium);
    color: $primary;
  }

  .modal-body {
    height: 250px;
    overflow: auto;
    padding: 0 0px 20px 0px;

    label {
      margin-bottom: 34px;
      @include fontItems(18px, normal, $font-weight-medium);
    }
  }

  .modal-footer {
    padding: 25px 5px;

    .btn {
      padding: 7px 44px;

      & .btn {
        margin-left: 20px;
      }
    }

    text-align: right;
  }
}

@media screen and (min-width: 568px) and (max-width: 1024px) {
  .switchAccModal {
    .modal-dialog {
      vertical-align: top;
      margin-top: 100px;
    }
  }
}

@media only screen and (max-width: 567px) {
  .switchAccModal {
    .modal-dialog {
      width: 95%;
    }
  }
}

@media (max-width: 375px) {
  .switchAccModal {
    .modal-dialog {
      width: 90%;
    }

    .modal-footer {
      padding: 0px 0px 10px 0px;
    }
  }
}
</style>